import { Link } from 'react-router-dom';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';

export default function CTASection() {
  const { ref: contentRef, isVisible: contentVisible } = useScrollAnimation({ threshold: 0.2 });

  return (
    <section className="relative py-36 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/edited_815723bcee058b1e1a9ca58945bf502e_a9379ba0.jpg"
          alt="강남 인테리어 CTA"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/25" />
      </div>
      <div
        ref={contentRef as React.RefObject<HTMLDivElement>}
        className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 text-center"
        style={{
          opacity: contentVisible ? 1 : 0,
          transform: contentVisible ? 'translateY(0) scale(1)' : 'translateY(40px) scale(0.97)',
          transition: 'opacity 0.9s ease, transform 0.9s ease',
        }}
      >
        <span className="text-[#c9a84c] text-xs tracking-[0.3em] uppercase font-medium">Free Estimate</span>
        <h2 className="text-3xl sm:text-4xl md:text-6xl font-light text-white mt-3 md:mt-4 mb-4 md:mb-6 leading-snug md:leading-tight" style={{ fontFamily: "'Noto Serif KR', serif" }}>
          지금 바로<br />
          <span className="font-semibold">무료 견적 받기</span>
        </h2>
        <p className="text-white/70 text-sm md:text-lg mb-8 md:mb-10 max-w-lg mx-auto leading-relaxed">
          feel green 전문가가 정확한 견적을 제공합니다.<br />
          상담부터 완공까지 책임지겠습니다.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center items-center">
          <Link
            to="/estimate"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-3 bg-[#c9a84c] text-[#0d0d0d] font-bold text-sm px-10 py-3.5 md:py-4 rounded-full whitespace-nowrap cursor-pointer hover:bg-[#b8973b] transition-all duration-300"
          >
            <i className="ri-calculator-line" />
            견적 신청하기
          </Link>
          <Link
            to="/consultation"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-3 border border-white/50 text-white text-sm px-10 py-3.5 md:py-4 rounded-full whitespace-nowrap cursor-pointer hover:bg-white/10 transition-all duration-300"
          >
            <i className="ri-chat-3-line" />
            전문가 상담 신청
          </Link>
        </div>
      </div>
    </section>
  );
}
